import { ScreenType } from '@frontend/wizard/types';

import ConfirmTransactionPrintLabels from '../screens/confirm-transaction-print-labels/confirm-transaction-print-labels.component';
import ConfirmTransaction from '../screens/confirm-transaction/confirm-transaction.component';
import EnterParcelInformation from '../screens/enter-parcel-information/enter-parcel-information.component';
import EnterProductCategory from '../screens/enter-product-category/enter-product-category.component';
import EnterProductInformation from '../screens/enter-product-information/enter-product-information.component';
import EnterProductTranslations from '../screens/enter-product-translations/enter-product-translations.component';
import EnterPurchaseOrder from '../screens/enter-purchase-order/enter-purchase-order.component';
import EnterReceiverSupplier from '../screens/enter-receiver-supplier/enter-receiver-supplier.component';
import EnterShippingNotes from '../screens/enter-shipping-notes/enter-shipping-notes.component';
import EnterTrackingNumberAndShippingNotes from '../screens/enter-tracking-number-and-shipping-notes/enter-tracking-number-and-shipping-notes.component';
import EnterTrackingNumber from '../screens/enter-tracking-number/enter-tracking-number.component';
import ProveIdentity from '../screens/prove-identity/prove-identity.component';
import WizardScreenNotFound from '../screens/screen-not-found/screen-not-found.component';
import SelectLocationSlotRequired from '../screens/select-location-slot-required/select-location-slot-required.component';
import SelectLocation from '../screens/select-location/select-location.component';
import SelectReceivers from '../screens/select-receivers/select-receivers.component';
import SelectSendersAndReceiversWithProofOfIdentity from '../screens/select-senders-and-receivers-with-proof-of-identity/select-senders-and-receivers-with-proof-of-identity.component';
import SelectSendersAndReceivers from '../screens/select-senders-and-receivers/select-senders-and-receivers.component';
import SelectSenders from '../screens/select-senders/select-senders.component';
import { TransactionMethod } from '../screens/transaction-method/transaction-method.component';
import { TransactionScheduling } from '../screens/transaction-scheduling/transaction-scheduling.component';
import VerifyOrderStockRequirement from '../screens/verify-order-stock-requirement/verify-order-stock-requirement.component';

const ScreenRenderer = (props: { screen_type: ScreenType; wizard_id: string }) => {
    switch (props.screen_type) {
        case ScreenType.ENTER_PURCHASE_ORDER:
            return <EnterPurchaseOrder wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_RECEIVER_SUPPLIER:
            return <EnterReceiverSupplier wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_PARCEL_INFORMATION:
            return <EnterParcelInformation wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_PRODUCT_INFORMATION:
            return <EnterProductInformation wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_PRODUCT_CATEGORY:
            return <EnterProductCategory wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_PRODUCT_TRANSLATIONS:
            return <EnterProductTranslations wizard_id={props.wizard_id} />;
        case ScreenType.CONFIRM_TRANSACTION:
            return <ConfirmTransaction wizard_id={props.wizard_id} />;
        case ScreenType.CONFIRM_TRANSACTION_PRINT_LABELS:
            return <ConfirmTransactionPrintLabels wizard_id={props.wizard_id} />;
        case ScreenType.PROVE_IDENTITY:
            return <ProveIdentity wizard_id={props.wizard_id} />;
        case ScreenType.SELECT_SENDERS:
            return <SelectSenders wizard_id={props.wizard_id} />;
        case ScreenType.SELECT_RECEIVERS:
            return <SelectReceivers wizard_id={props.wizard_id} />;
        case ScreenType.SELECT_SENDERS_AND_RECEIVERS:
            return <SelectSendersAndReceivers wizard_id={props.wizard_id} />;
        case ScreenType.SELECT_SENDERS_AND_RECEIVERS_WITH_PROOF_OF_IDENTITY:
            return <SelectSendersAndReceiversWithProofOfIdentity wizard_id={props.wizard_id} />;
        case ScreenType.SELECT_LOCATION:
            return <SelectLocation wizard_id={props.wizard_id} />;
        case ScreenType.SELECT_LOCATION_SLOT_REQUIRED:
            return <SelectLocationSlotRequired wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_TRACKING_NUMBER:
            return <EnterTrackingNumber wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_SHIPPING_NOTES:
            return <EnterShippingNotes wizard_id={props.wizard_id} />;
        case ScreenType.ENTER_TRACKING_NUMBER_AND_SHIPPING_NOTES:
            return <EnterTrackingNumberAndShippingNotes wizard_id={props.wizard_id} />;
        case ScreenType.TRANSACTION_METHOD:
            return <TransactionMethod wizard_id={props.wizard_id} />;
        case ScreenType.TRANSACTION_SCHEDULING:
            return <TransactionScheduling wizard_id={props.wizard_id} />;
        case ScreenType.VERIFY_ORDER_STOCK_REQUIREMENT:
            return <VerifyOrderStockRequirement wizard_id={props.wizard_id} />;
        default:
            return <WizardScreenNotFound />;
    }
};

export default ScreenRenderer;
